import * as api from '../../services/api';

export const getSystems = () => api.get('data/ictsupport/systems/');

export const getFavouriteSystems = () =>
  api.get('data/ictsupport/systems/search?favourites=true');
